module.exports = __webpack_public_path__ + "static/media/banner-right-circle-dark.5e3c7f00.png";